<template>
  <button type="button" class="btn btn-primary" @click="show = true">Send Mail</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Send Mail</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="">Mail Subject:</label>
            <input type="text" class="form-control" v-model="mail.subject">
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="fw-bold" for="">Inserts</label>
                <div class="form-check" v-for="Insert in getInserts()" :key="Insert.id">
                  <input class="form-check-input" type="checkbox" :value="Insert.id" :id="Insert.id" v-model="mail.inserts">
                  <label class="form-check-label" :for="Insert.id">
                    {{ Insert.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="fw-bold" for="">PDF attachments</label>
                <div class="form-check" v-for="pdf in mail_pdfs" :key="pdf.id">
                  <input class="form-check-input" type="checkbox" :value="pdf.id" :id="`pdf${pdf.id}`" v-model="mail.pdfs">
                  <label class="form-check-label" :for="`pdf${pdf.id}`">
                    {{ pdf.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="">Mail body:</label>
            <editor
              api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
              v-model="mail.body"
              :init="{
                height: 300,
                menubar: false,
                plugins: ['lists', 'link', 'code'],
                toolbar:
                  'undo redo | styles | forecolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link code'
              }"
            />
          </div>
          <div class="mb-3">
            <label for="">Available tags:</label>
            <div class="tags">
              <span class="tag" v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="sendMail()">Send Mail</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash/throttle'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'SendMail',
  components: {
    Editor
  },
  props: ['bookings', 'form', 'mail_templates', 'mail_inserts', 'mail_pdfs'],
  data() {
    return {
      show: false,
      mail: this.$inertia.form({
        subject: null,
        code: this.form.status,
        group: this.form.agencies_id == 1 ? 'customer' : 'agency',
        body: null,
        template: null,
        inserts: [],
        pdfs: []
      }),
      tags: [
        '{{ agency_name }}',
        '{{ agent_firstname }}',
        '{{ agent_lastname }}',
        '{{ customer_company }}',
        '{{ customer_title }}',
        '{{ customer_firstname }}',
        '{{ customer_middlename }}',
        '{{ customer_lastname }}',
        '{{ booking_number }}',
        '{{ ticket_count }}',
        '{{ passengers }}',
        '{{ operator }}',
        '{{ journeys }}',
        '{{ itinerary }}',
        '{{ cost_overview }}',
        '{{ grand_total }}',
        '{{ payment_url }}'
      ]
    }
  },
  mounted() {
    this.getSubject()
  },
  methods: {
    getInserts() {
      let inserts = this.mail_inserts.filter(obj => {
        return obj.group === 'customer'
      })
      return inserts
    },
    getSubject() {
      let set_subject = this.mail_templates.filter(obj => {
        return obj.code === this.form.status
      })

      this.mail.subject = set_subject[0].name
      this.mail.template = set_subject[0].html_template
    },
    sendMail() {
        this.mail.put(`/bookings/${this.bookings.id}/mail`)
        this.mail.template_id = null
        this.show = false
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.getSubject()
      })
    }
  }
}
</script>

<style lang="scss">
.tags {
  .tag {
    display: inline-block;
    padding: 0.225rem 0.5rem;
    font-size: 0.875rem;
    background: var(--bs-gray-200);
    margin-bottom: 0.25rem;
    margin-right: 0.25rem;
    border-radius: 3px;
  }
}
</style>
